const translations = {
  "en": {
    "Please agree to the Privacy Policy first": "Please agree to the Privacy Policy first"
  },
  "zh-tw": {
    "Please agree to the Privacy Policy first": "請先同意隱私權政策"
  }
};

export default translations;
